module.exports = __webpack_public_path__ + "img/1.ec1ed6a3.png";